import { PROFILE_DETAILS } from '@client/actions';
import { Action } from '@client/lib/action';

export class ProfileDetailsDestroyAction implements Action {
	readonly type = PROFILE_DETAILS.DESTROY;
	constructor(public payload?: null, public correlationId?: number) {}
}

export class ProfileDetailsInitAction implements Action {
	readonly type = PROFILE_DETAILS.INIT;
	constructor(public payload?: null, public correlationId?: number) {}
}
